/** 대회 접수 지역(시·도) 옵션 */
export const REGION_OPTIONS: { label: string; value: string }[] = [
  { label: "서울특별시", value: "SEOUL" },
  { label: "부산광역시", value: "BUSAN" },
  { label: "인천광역시", value: "INCHEON" },
  { label: "대구광역시", value: "DAEGU" },
  { label: "대전광역시", value: "DAEJEON" },
  { label: "광주광역시", value: "GWANGJU" },
  { label: "울산광역시", value: "ULSAN" },
  { label: "세종특별자치시", value: "SEJONG" },
  { label: "경기도", value: "GYEONGGI" },
  { label: "강원특별자치도", value: "GANGWON" },
  { label: "충청북도", value: "CHUNGBUK" },
  { label: "충청남도", value: "CHUNGNAM" },
  { label: "전북특별자치도", value: "JEONBUK" },
  { label: "전라남도", value: "JEONNAM" },
  { label: "경상북도", value: "GYEONGBUK" },
  { label: "경상남도", value: "GYEONGNAM" },
  { label: "제주특별자치도", value: "JEJU" },
];
